<template>
<div class="container">
  <div class="culture-container">
    <div class="culture-container-box1">
      <div class="box1-header">
        <div class="box1-header-text">核心价值观</div>
        <div class="box1-heaer-logo"></div>
      </div>
      <div class="box1-header-english">CORE VALUES</div>
      <div class="box1-container">
        <div class="box1-container-img1"></div>
        <div class="box1-container-img2"></div>
        <div class="box1-container-english">INFLUENCE & INNOVATION</div>
      </div>
      <div class="box1-text">一、打造有影响力的的科技创新产品和团队是公司的宗旨。<br> 二、有影响力的产品是指完善的产品技术，力争在行业中崭露头角。<br> 三、有影响力的团队是指有专业性，有市场认可度的技术性团队，力争每一个客户的认可。<br> 四、我们希望给市场带来更多的活力和不同，我们希望给市场带来的是更多的影响力和创新。</div>
    </div>

    <div class="culture-container-box2">
       <div class="box2-header">
        <div class="box2-header-text">公司活动</div>
        <div class="box2-heaer-logo"></div>
      </div>
      <div class="box1-header-english">COMPANY EVENT</div>
      <div class="box2-container">
        <div class="box2-picture"><img src="@/assets/companyimages/tuanjian1.png">公司团建1</div>
        <div class="box2-picture"><img src="@/assets/companyimages/tuanjian2.png">公司团建2</div>
        <div class="box2-picture"><img src="@/assets/companyimages/tuanjian3.png">公司团建3</div>
      </div>
    </div>
  </div>
  <Footer></Footer>
</div>
</template>

<script>
import Footer from "../../../componets/footer/Footer.vue"
export default {
  components: {
    Footer
  }
}
</script>

<style lang="less" scoped>
.culture-container {
  width: 12rem;
  margin: 0 3.6rem;
}
//box1中头部的样式
.culture-container-box1 {
  width: 12rem;
  height: 4.86rem;
  margin-bottom: 0.6rem;
}
.box1-header {
  display: flex;
  justify-content:space-between
}
.box1-header-text {
  width: 1.9rem;
  height: 0.56rem;
  font-size: 0.38rem;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 0.56rem;
  color: #333333;
}
.box1-heaer-logo {
  width: 1.06rem;
  height: 0.2rem;
  margin-top: 0.18rem;
  background-image: url("../../../assets/companyimages/组 148.png");
  background-size: 1.06rem 0.2rem;
  background-repeat: no-repeat;
}
.box1-header-english {
  width: 3rem;
  height: 0.34rem;
  font-size: 0.28rem;
  text-align: left;
  font-family: DIN;
  font-weight: normal;
  line-height: 0.34rem;
  color: #747474;
  opacity: 0.5;
  margin-top: 0.14rem;
}
.box1-container {
  width: 12rem;
  height: 3.52rem;
  margin-top: 0.3rem;
  display: flex;
}
//box1中的内容
.box1-container {
  display: flex;
}
.box1-container-img1 {
  width: 3.52rem;
  height: 3.52rem;
  background-image: url("../../../assets/companyimages/核心.png");
  background-size: 3.52rem 3.52rem;
  background-repeat: no-repeat;
}
.box1-container-img2 {
  width: 2.48rem;
  height: 2.48rem;
  background-color: #F3F6FD;
  margin-top: 1.04rem;
}
.box1-container-english {
  width: 3.5rem;
  height: 0.27rem;
  font-size: 0.22rem;
  font-family: DIN;
  font-weight: normal;
  line-height: 0.27rem;
  color: #666666;
  margin-top: 3.25rem;
  margin-left: 3.31rem;
}
.box1-text {
  width: 6.65rem;
  height: 2.23rem;
  font-size: 0.22rem;
  text-align: left;
  line-height: 0.44rem;
  font-family: Source Han Sans CN;
  font-weight: 400;
  position: absolute;
  top: 10.39rem;
  left: 8.95rem;
  color: #666666;
}

//box2的样式
.culture-container-box2 {
  width: 12rem;
  height: 4.36rem;
  margin-bottom: 0.6rem;
}

.box2-header {
  display: flex;
  justify-content:space-between
}
.box2-header-text {
  width: 1.9rem;
  height: 0.56rem;
  font-size: 0.38rem;
  text-align: left;
  font-family: Source Han Sans CN;
  font-weight: 500;
  line-height: 0.56rem;
  color: #333333;
}
.box2-heaer-logo {
  width: 1.06rem;
  height: 0.2rem;
  margin-top: 0.18rem;
  background-image: url("../../../assets/companyimages/组 149.png");
  background-size: 1.06rem 0.2rem;
  background-repeat: no-repeat;
}
.box2-container {
  width: 12rem;
  height: 3.06rem;
  margin-top: 0.3rem;
  color: #666666;
  display: flex;
  justify-content:space-between
}
.box2-container img {
  width: 3.84rem;
  height: 2.63rem;
}
.box2-picture {
  width: 3.84rem;
  height: 3.06rem;
  line-height: 0.3rem;
  font-size: 0.3rem;
}
.box2-picture :hover {
  animation: scale-in-center 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}
//图片的动画效果
@keyframes scale-in-center {
  0% {
    -webkit-transform: scale(1);
            transform: scale(1);
    opacity: 1;
  }
  100% {
    -webkit-transform: scale(1.1);
            transform: scale(1.1);
    opacity: 1;
  }
}
</style>
